// app/javascript/recipes/filtering/triggers/order.js

import actions from '../actions';
import onReady from '../../../../helpers/onReady'


onReady(() => {
  actions.order.setDropdown();
});
